import { render, staticRenderFns } from "./advisoryList.vue?vue&type=template&id=725d7a4f&scoped=true&"
import script from "./advisoryList.vue?vue&type=script&lang=js&"
export * from "./advisoryList.vue?vue&type=script&lang=js&"
import style0 from "./advisoryList.vue?vue&type=style&index=0&id=725d7a4f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "725d7a4f",
  null
  
)

export default component.exports